module.exports = require('./shortid.js');


/*****************
 ** WEBPACK FOOTER
 ** ./lib/shortid/index.js
 ** module id = 204
 ** module chunks = 0
 **/